var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63551 20.4688L4.03134 21.0521V11.6458L1.50009 17.75C1.07301 18.8125 1.58343 20.0313 2.63551 20.4688ZM22.948 16.6146L17.7813 4.14584C17.4584 3.36459 16.698 2.88543 15.8959 2.86459C15.6251 2.86459 15.3438 2.90626 15.073 3.02084L7.39593 6.19793C6.61468 6.52084 6.13551 7.27084 6.11468 8.07293C6.10426 8.35418 6.15634 8.63543 6.27093 8.90626L11.4376 21.375C11.7605 22.1667 12.5313 22.6458 13.3438 22.6563C13.6147 22.6563 13.8855 22.6042 14.1459 22.5L21.8126 19.3229C22.8751 18.8854 23.3855 17.6667 22.948 16.6146ZM8.20843 9.11459C7.63551 9.11459 7.16676 8.64584 7.16676 8.07293C7.16676 7.50001 7.63551 7.03126 8.20843 7.03126C8.78134 7.03126 9.25009 7.50001 9.25009 8.07293C9.25009 8.64584 8.78134 9.11459 8.20843 9.11459ZM6.12509 20.5729C6.12509 21.7188 7.06259 22.6563 8.20843 22.6563H9.71884L6.12509 13.9688V20.5729Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle);
export default __webpack_public_path__ + "static/media/style.971b312d6e39383e9926e5addcc6939b.svg";
export { ForwardRef as ReactComponent };